import { SVGProps, useId } from "react";

export default function OpenLocationIcon(props: SVGProps<SVGSVGElement>) {
  const { height = 20, width = 20, ...rest } = props;
  const id = useId();

  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 20 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...rest}
    >
      <path
        opacity="0.4"
        d="M6.50977 2.16669H13.4932C14.9103 2.16673 15.9811 2.58737 16.6963 3.30341C17.4113 4.01934 17.83 5.08984 17.8262 6.50653V13.4919C17.8261 14.9088 17.4056 15.9796 16.6895 16.696C15.9731 17.4124 14.9016 17.8337 13.4844 17.8337H6.50977C5.09254 17.8337 4.021 17.4132 3.30469 16.696C2.58832 15.9787 2.16797 14.9048 2.16797 13.4831V6.50848C2.16797 5.09125 2.58831 4.01978 3.30469 3.30341C4.02106 2.58703 5.09253 2.16669 6.50977 2.16669Z"
        fill={`url(#open_location_bg_${id})`}
        stroke="#E3592E"
      />
      <path
        d="M9.93359 6.33331H13.959C13.9891 6.33335 14.0203 6.34579 14.0459 6.3714C14.0715 6.39703 14.084 6.42819 14.084 6.45831V10.4837C14.0839 10.5137 14.0714 10.5451 14.0459 10.5706C14.0203 10.5961 13.989 10.6087 13.959 10.6087C13.9289 10.6087 13.8977 10.5961 13.8721 10.5706C13.8465 10.5451 13.8341 10.5137 13.834 10.4837V6.75909L6.54688 14.0462C6.53238 14.0607 6.51858 14.0693 6.50586 14.0745C6.49257 14.0799 6.47661 14.0833 6.45898 14.0833C6.4413 14.0833 6.42543 14.0799 6.41211 14.0745C6.39934 14.0693 6.38565 14.0607 6.37109 14.0462C6.34957 14.0247 6.33594 13.9942 6.33594 13.9583C6.33594 13.9225 6.34957 13.8919 6.37109 13.8704L12.8037 7.43683L13.6572 6.58331H9.93359C9.90353 6.58324 9.87225 6.5708 9.84668 6.54523C9.82112 6.51961 9.80859 6.48841 9.80859 6.45831C9.80859 6.42822 9.82112 6.39702 9.84668 6.3714C9.87225 6.34583 9.90353 6.33338 9.93359 6.33331Z"
        fill={`url(#open_location_arrow_${id})`}
        stroke="#E3592E"
      />
      <defs>
        <linearGradient
          id={`open_location_bg_${id}`}
          x1="9.99715"
          y1="1.66669"
          x2="9.99715"
          y2="18.3334"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
        <linearGradient
          id={`open_location_arrow_${id}`}
          x1="10.2099"
          y1="5.83331"
          x2="10.2099"
          y2="14.5833"
          gradientUnits="userSpaceOnUse"
        >
          <stop stopColor="#F56F10" />
          <stop offset="1" stopColor="#F52310" />
        </linearGradient>
      </defs>
    </svg>
  );
}
